<template>
	<div>
		<div>
			<div>
				<div class="outerBorder">
					<div class="agreementDiv">
						<span class="textHeader">CUSIP Agreement</span>
						<textarea class="agreementTextArea" v-model="agreement" disabled> </textarea>
					</div>
					<table width="100%">
						<tr style="">
							<td width="25%" class="ackTD">Acknowledge: </td>
							<td width="25%"><input type="checkbox" id="rulesCheck" class="checkBox"> </td>
							<td><el-button class="submitButton" size="medium" @click="submit">
								Submit
							</el-button></td>
						</tr>
					</table>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import HTTP_API from '@/utils/http-api'

export default {
	data(){
		return {
			agreement: ""
		}
	},
  methods: {
	  submit() {
		  	var vm = this
		  	var dang1
			if (document.getElementById("rulesCheck").checked == true) {
				HTTP_API.post('/account/cusipagreement')
				.then(response => {
				    let lenderId = response.data
					vm.$router.push({ name: "home",params: {lenderId: parseInt(lenderId)} })
				})
				.catch(error => {
					console.log(error)
				})
			} else if (document.getElementById("rulesCheck").checked != true) {
				vm.$alert('Cusip Agreement needs to be acknowledged (checkbox checked).', 'Warning!', { confirmButtonText: 'OK' })
				dang1 = document.getElementsByClassName("el-button el-button--default el-button--small el-button--danger")
				if (dang1 && dang1.length != 0) {
					dang1[0].className = "el-button el-button--default el-button--small el-button--primary"
				}
			}
		},
		getAgreementText(){
			var vm = this
			vm.loading=true;
			HTTP_API.get('/account/cusipagreementtext/')
			.then(response => {
				vm.agreement = response.data;
			})
			.catch(function (error) {
				console.log(error.response)

			})
		}
  	},
	mounted(){
		this.getAgreementText();
	}
}
</script>

<style scoped>

.outerBorder {
	margin-left:15%;
	margin-right:15%;
	text-align:left;
	margin-top:10px;
  border: 1.8px solid rgba(31, 31, 31, 0.527);
	background-color: rgba(250, 245, 245, 0.89);
    box-shadow: 0 0 5px silver;
}

.agreementDiv {
	font-size: 14px;
	padding: 10px 10px 0px 10px;
}
.agreementTextArea {
	background-color:#D4D8F9;
  width: 100%;
  min-width: 500px;
  height: 450px;
  border: 1.5px solid rgba(53, 52, 52, 0.527);
  padding: 2px 2px 2px 2px 2px;
}

.textHeader {
	margin-left:40%;
    margin-right:25%;
	color:#1867C0;
	font-size: 16px;
	padding: 10px;
	font-weight: bold;
}

.ackTD {
	font-size: 14px;
	font-weight: bold;
	color:#1867C0;
	float: right;
	margin-top: 12px;
	margin-right: 6px;
}

.checkBox {
	float: left;
	margin: 12px 10px 20px;
}

.submitButton {
	margin-left:10%;
    margin-right:35%;
	margin-top: 12px;
	color: white;
	background-color: #1867C0;
  margin-bottom:10px;
}

</style>
